import React from 'react';
import './TermsOfUse.css';

const TermsOfUse = () => {
  return (
    <div className="terms-container">
      <h1 className="title">Terms of Use</h1>
      <p className="updated-date"><strong>Last Updated:</strong> June 12, 2025</p>

      <p>
        Welcome to <strong>VORTREX</strong>. These Terms of Use ("Terms") govern your access to and use of the VORTREX AI Trading Bot, our website, and any related services. By connecting your wallet or using any part of this platform, you agree to these Terms. If you do not agree, please disconnect and discontinue use.
      </p>

      <h2>🧾 Use of This Platform</h2>
      <p>
        The VORTREX Bot is an experimental automation tool for educational and informational purposes only. It is not a financial advisory service, exchange, or guaranteed return platform.
      </p>

      <h2>📉 No Investment Advice</h2>
      <p>
        This platform does <strong>not</strong> offer financial or investment advice. Use of the bot is voluntary and at your own discretion. Always DYOR (Do Your Own Research) before participating in any crypto activity.
      </p>

      <h2>🧠 Eligibility</h2>
      <p>
        You must be at least 18 years old to access or interact with the VORTREX platform. By connecting your wallet, you confirm that you meet this age requirement.
      </p>

      <h2>💼 Wallet Connection</h2>
      <p>
        The platform allows connection to Web3 wallets like MetaMask or Trust Wallet. We <strong>never</strong> ask for your private keys, seed phrases, or full wallet access. The bot operates only with limited permissions (i.e., trading access) and does not withdraw funds.
      </p>

      <h2>⚙️ Trading Bot Use</h2>
      <p>
        VORTREX executes algorithmic trades based on AI signals, directly from your connected wallet. It does not hold or store user funds. Users are fully responsible for approving, monitoring, and managing access permissions.
      </p>

      <h2>📜 Intellectual Property</h2>
      <p>
        All platform content, branding, logic, and visuals are owned by VORTREX or used under license. Unauthorized use, reproduction, or redistribution is prohibited.
      </p>

      <h2>🔒 Limitation of Liability</h2>
      <p>
        VORTREX shall not be held liable for any financial loss, technical malfunction, or wallet mismanagement arising from use of the bot or associated tools.
      </p>

      <h2>❌ Prohibited Activities</h2>
      <ul>
        <li>Attempting to exploit or reverse engineer the trading logic</li>
        <li>Using unauthorized bots, scripts, or automation outside our system</li>
        <li>Engaging in illegal activity or violating local crypto regulations</li>
      </ul>

      <h2>🔁 Changes to These Terms</h2>
      <p>
        These Terms may be modified or updated at any time without prior notice. Continued use of the platform implies acceptance of the latest terms.
      </p>

      <h2>📬 Contact Us</h2>
      <p>
        <strong>Email:</strong> support@vortrex.live<br />
        <strong>Website:</strong> <a href="https://vortrex.live" target="_blank" rel="noopener noreferrer">https://vortrex.live</a>
      </p>
    </div>
  );
};

export default TermsOfUse;
